<script setup lang="ts">
  import { useGoogleAnalytics } from '@/shared/composables'
  import AiraloPopup from '../AiraloPopup'
  import { ref } from 'vue'

  const gaService = useGoogleAnalytics()

  const showPopup = ref(false)
  const isSendCloseEvent = ref(false)

  const openPopup = () => {
    isSendCloseEvent.value = true
    showPopup.value = true
    gaService.sendAiraloPopupOpened()
  }

  const closePopup = () => {
    showPopup.value = false
    if (isSendCloseEvent.value) {
      gaService.sendAiraloPopupClosed()
    }
  }

  const buyPolicyClick = () => {
    isSendCloseEvent.value = false
    gaService.sendAiraloPopupClosed('buy_policy')
  }
</script>

<template>
  <div class="airalo-banner">
    <div class="airalo-banner__badge">{{ $t('check_quote.airalo.badge') }}</div>
    <div class="airalo-banner__wrapper">
      <div class="airalo-banner__content">
        <div class="airalo-banner__content-inner">
          <div class="airalo-banner__text">
            <h3 class="airalo-banner__title">{{ $t('check_quote.airalo.header') }}</h3>
            <p class="airalo-banner__description">
              {{ $t('check_quote.airalo.desc') }}
              <span class="airalo-banner__learn-more" @click="openPopup">
                {{ $t('check_quote.airalo.link') }}
              </span>
            </p>
          </div>
          <div class="airalo-banner__logo">
            <img src="@/shared/assets/images/airalo-icon.svg" alt="airalo-logo" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <AiraloPopup v-if="showPopup" @close="closePopup" @buy-policy-click="buyPolicyClick" />
</template>

<style scoped lang="scss">
  @use './AiraloBanner';
</style>
